@if (active) {
<div class="wrapper">
  <div class="content-wrapper" @simpleFade>
    <ng-content select="[content]"></ng-content>
  </div>
  <div class="actions">
    <div class="actions-wrapper">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</div>
}
